import { render } from "./CreateAbsenceComponent.vue?vue&type=template&id=0a48e93c"
import script from "./CreateAbsenceComponent.vue?vue&type=script&lang=js"
export * from "./CreateAbsenceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__